<div class="edit-trailer-type-contract">
  <div class="border-b border-gray-400 pb-1 mb-2 title">
    Edit Trailer Type Contract
  </div>
  <form [formGroup]="newTrailerTypeContractForm" (ngSubmit)="patchTrailerTypeContract()">
    <mat-form-field class="w-full" style="line-height: 2.5;">
      <mat-label class="py-1 px-1">Trailer Type</mat-label>
      <mat-select formControlName="trailerTypeId" [disabled]="true">
        <mat-option
          *ngFor="let trailerType of trailerTypes$ | async; trackBy: trackByTrailerType"
          [value]="trailerType.id"
        >
          {{ trailerType.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="w-full" style="line-height: 2.5;">
      <mat-label class="py-1 px-1">Contract</mat-label>
      <mat-select formControlName="vendorContractId">
        <mat-option
          *ngFor="let vendorContract of vendorContracts$ | async; trackBy: trackByVendorContract"
          [value]="vendorContract.id"
        >
          {{ vendorContract.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <div class="grid grid-flow-col justify-items-center gap-2" style="justify-content: stretch">
      <button class="cancel-btn" type="button" (click)="close()">Cancel</button>
      <sa-network-active-button [active]="activeNetworkRequest$ | async" class="update-btn">
        <button type="submit" [disabled]="newTrailerTypeContractForm.invalid">Update</button>
      </sa-network-active-button>
    </div>
  </form>
</div>
